var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 52,
    viewBox: "0 0 36 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 52L7.2 35.68H0.8V31.12H7.76L9.2 19.28H2.4V14.64H9.76L11.6 -2.86102e-06H15.84L14 14.64H24.64L26.56 -2.86102e-06H30.8L28.88 14.64H35.36V19.28H28.4L26.96 31.12H33.76V35.68H26.4L24.4 52H20.16L22.08 35.68H11.52L9.52 52H5.2ZM12.08 31.12H22.64L24.08 19.28H13.52L12.08 31.12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.1528bd4f55c96ab55bae135e43b42ff3.svg";
export { ForwardRef as ReactComponent };